import type { parseHtml } from '@change-corgi/core-react/html';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useLoginOrSignupPageState } from '#src/app/pages/loginOrSignup/pageContext';
import { useSapCyclingProofExperiment } from '#src/app/pages/loginOrSignup/shared/hooks';
import type { LoginOrSignupStep } from '#src/app/pages/loginOrSignup/shared/types';

import { getI18nKeys } from './i18nKeys';

type Result = ModelHookResult<{
	step: LoginOrSignupStep;
	title: string;
	subtitle?: ReturnType<typeof parseHtml>;
}>;

export function useLoginOrSignupHeader(): Result {
	const [{ currentStep, email }] = useLoginOrSignupPageState();
	const { typedTranslate, typedTranslateHtml } = useI18n();
	const {
		data: { isTreatment },
	} = useSapCyclingProofExperiment();

	const { title, subtitle } = getI18nKeys(currentStep, { sapCyclingProofTreatment: isTreatment });

	return {
		data: {
			step: currentStep,
			title: typedTranslate(title),
			subtitle: subtitle && typedTranslateHtml(subtitle, { emailAddress: email }),
		},
	};
}
